import React, { Component } from 'react';
import './App.css';
//import './Header.css';


class Header extends Component {
  render() {
    return (
        <h2 align="center"> Lamill Websystems Timeline of PHEVs
        </h2>
    );
  }
}

export default Header;